/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  BATCH_CREATE,
  BATCH_LIST,
  BATCH_UPDATE,
  BATCH_DETAILS,
  BATCH_EXAMS,
  BATCH_MEMBERS,
  BATCH_BULK_UPLOAD_EXTERNAL_CANDIDATES,
  BATCH_BULK_UPLOAD_EMPLOYEES,
  FETCH_BULK_UPLOAD_DETAILS,
  GET_BATCH_RESUMES,
  UPLOAD_BATCH_RESUME,
  BATCH_RESULT,
  GET_RESUME_DATA,
  GET_EXTERNAL_CANDIDATE,
  GET_BATCH_INVITATION,
  SEND_UPDATED_RESUME_DATA,
  SEND_DUPLICATE_RESUME_DATA,
  GET_RECRUITMENT_JD_INVITATION,
  GET_SKILL_SET,
  SET_SKILL_SET,
  PROCESS_JS_SKILL_SET,
  GET_SKILL_SET_LIST,
} from '../constants/action-types'
import { BatchData } from '../Actions'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { ActionTypes } from '../action'

const initialState = {
  isLoading: false,
  errorMessage: '',
  batchList: { data: [] },
  batchDetails: Object,
  batchExams: [],
  batchMembers: [],
  isLoadingBatchMembers: false,
  bulkUploadDetails: Object,
  isLoadingBatchResumes: false,
  batchResumes: { count: 0, results: [] },
  batchResult: [],
  extractedResumeData: [],
  instituteUsers: [],
  batchInvitations: { count: 0, results: [] },
  updatedResumeData: [],
  duplicateResumeData: [],
  jdInvitations: { count: 0, results: [] },
  skillSetList: [],
  skillList: [],
  isLoadingSkillList: false,
  isLoadingGetSkillSet: false,
  isLoadingSetSkillSet: false,
  isLoadingProcessJDSkillSet: false,
  ProcessJDSkillSet: [],
}
// comment added
const reducer = persistReducer(
  { storage, key: 'basecode-demo', whitelist: ['user'] },
  (state: BatchData = initialState, action: ActionTypes) => {
    switch (action.type) {
      case BATCH_LIST.BATCH_LIST_INITIALIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: true,
          batchList: { data: [] },
        }
      case BATCH_LIST.BATCH_LIST_SUCCESS:
        const batch: any = action.payload
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: false,
          batchList: batch,
        }

      case BATCH_LIST.BATCH_LIST_ERORR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isLoading: false,
          batchList: { data: [] },
        }

      case BATCH_MEMBERS.BATCH_MEMBERS_INITIALIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoadingBatchMembers: true,
        }
      case BATCH_MEMBERS.BATCH_MEMBERS_SUCCESS:
        const members: any = action.payload
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoadingBatchMembers: false,
          batchMembers: members,
        }

      case BATCH_MEMBERS.BATCH_MEMBERS_ERROR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isLoadingBatchMembers: false,
        }
      //create batch
      case BATCH_CREATE.BATCH_CREATE_INITIALIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: true,
        }
      case BATCH_CREATE.BATCH_CREATE_SUCCESS:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: false,
        }

      case BATCH_CREATE.BATCH_CREATE_ERORR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isLoading: false,
        }

      //UPDATE batch
      case BATCH_UPDATE.BATCH_UPDATE_INITIALIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: true,
        }
      case BATCH_UPDATE.BATCH_UPDATE_SUCCESS:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: false,
        }

      case BATCH_UPDATE.BATCH_UPDATE_ERORR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isLoading: false,
        }
      //Details batch
      case BATCH_DETAILS.BATCH_DETAILS_INITIALIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: true,
        }
      case BATCH_DETAILS.BATCH_DETAILS_SUCCESS:
        const batchdetails: any = action.payload
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: false,
          batchDetails: batchdetails,
        }

      case BATCH_DETAILS.BATCH_DETAILS_ERORR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isLoading: false,
        }

      case BATCH_EXAMS.GET_BATCH_EXAMS_INITIALIZATION:
        return {
          ...state,
          isLoading: true,
        }
      case BATCH_EXAMS.GET_BATCH_EXAMS_SUCCESS:
        const payload: any = action.payload
        return {
          ...state,
          isLoading: false,
          batchExams: payload?.data || [],
        }

      case BATCH_BULK_UPLOAD_EMPLOYEES.BATCH_BULK_UPLOAD_EMPLOYEES_INITIALIZATION:
        return {
          ...state,
          isLoading: true,
        }
      case BATCH_BULK_UPLOAD_EMPLOYEES.BATCH_BULK_UPLOAD_EMPLOYEES_SUCCESS:
        return {
          ...state,
          isLoading: true,
          bulkUploadDetails: action.payload || {},
        }

      case BATCH_BULK_UPLOAD_EXTERNAL_CANDIDATES.BATCH_BULK_UPLOAD_EXTERNAL_CANDIDATES_INITIALIZATION:
        return {
          ...state,
          isLoading: true,
        }
      case BATCH_BULK_UPLOAD_EXTERNAL_CANDIDATES.BATCH_BULK_UPLOAD_EXTERNAL_CANDIDATES_SUCCESS:
        return {
          ...state,
          isLoading: true,
          bulkUploadDetails: action.payload || {},
        }

      case FETCH_BULK_UPLOAD_DETAILS.FETCH_BULK_UPLOAD_DETAILS_INITIALIZATION:
        return {
          ...state,
          isLoading: true,
          bulkUploadDetails: {},
        }
      case FETCH_BULK_UPLOAD_DETAILS.FETCH_BULK_UPLOAD_DETAILS_SUCCESS:
        return {
          ...state,
          isLoading: false,
          bulkUploadDetails: action.payload || {},
        }
      case FETCH_BULK_UPLOAD_DETAILS.FETCH_BULK_UPLOAD_DETAILS_RESET:
        return {
          ...state,
          isLoading: false,
          bulkUploadDetails: {},
        }
      case GET_BATCH_RESUMES.GET_BATCH_RESUMES_INITIALIZATION:
        return {
          ...state,
          isLoadingBatchResumes: true,
          batchResumes: { count: 0, results: [] },
        }
      case GET_BATCH_RESUMES.GET_BATCH_RESUMES_ERROR:
        return {
          ...state,
          isLoadingBatchResumes: false,
        }
      case GET_BATCH_RESUMES.GET_BATCH_RESUMES_SUCCESS:
        const batchResumes: any = action.payload
        return {
          ...state,
          isLoadingBatchResumes: false,
          batchResumes,
        }
      case UPLOAD_BATCH_RESUME.UPLOAD_BATCH_RESUME_INITIALIZATION:
        return { ...state, isLoading: true }

      case UPLOAD_BATCH_RESUME.UPLOAD_BATCH_RESUME_SUCCESS:
        return { ...state, isLoading: false }

      case UPLOAD_BATCH_RESUME.UPLOAD_BATCH_RESUME_FAILED:
        return { ...state, isLoading: false }

      case BATCH_RESULT.BATCH_RESULT_INITIALIZATION:
        return {
          ...state,
          isLoading: true,
          batchResult: [],
        }
      case BATCH_RESULT.BATCH_RESULT_SUCCESS:
        const result = action.payload as any
        return {
          ...state,
          isLoading: false,
          batchResult: result.data,
        }
      case BATCH_RESULT.BATCH_RESULT_ERROR:
        return {
          ...state,
          batchResult: [],
        }

      case BATCH_RESULT.BATCH_RESULT_RESET:
        return {
          ...state,
          isLoading: false,
        }

      case GET_RESUME_DATA.GET_RESUME_DATA_INITIALIZATION:
        return {
          ...state,
          isLoading: true,
        }
      case GET_RESUME_DATA.GET_RESUME_DATA_FAILED:
        return {
          ...state,
          isLoading: false,
        }

      case GET_RESUME_DATA.GET_RESUME_DATA_SUCCESS:
        const resumeData: any = action.payload
        return {
          ...state,
          extractedResumeData: resumeData,
          isLoading: false,
        }
      case GET_EXTERNAL_CANDIDATE.GET_EXTERNAL_CANDIDATE_INITIALIZATION:
        return {
          ...state,
          isLoading: true,
        }

      case GET_EXTERNAL_CANDIDATE.GET_EXTERNAL_CANDIDATE_SUCCESS:
        const candidates: any = action.payload
        return {
          ...state,
          isLoading: false,
          instituteUsers: candidates,
        }
      case GET_EXTERNAL_CANDIDATE.GET_EXTERNAL_CANDIDATE_FAILED:
        return {
          ...state,
          isLoading: false,
        }
      case GET_BATCH_INVITATION.GET_BATCH_INVITATION_INITIALIZATION:
        return {
          ...state,
          isLoading: true,
        }
      case GET_BATCH_INVITATION.GET_BATCH_INVITATION_SUCCESS:
        const batchInvitations: any = action.payload
        return {
          ...state,
          isLoading: false,
          batchInvitations,
        }
      case GET_BATCH_INVITATION.GET_BATCH_INVITATION_FAILED:
        return {
          ...state,
          isLoading: false,
        }

      case SEND_UPDATED_RESUME_DATA.SEND_UPDATED_RESUME_DATA_INITIALIZATION:
        return {
          ...state,
          updatedResumeData: action.payload,
          isLoading: false,
        }

      case SEND_DUPLICATE_RESUME_DATA.SEND_DUPLICATE_RESUME_DATA_INITIALIZATION:
        return {
          ...state,
          duplicateResumeData: action.payload,
          isLoading: false,
        }

      case GET_RECRUITMENT_JD_INVITATION.GET_RECRUITMENT_JD_INVITATION_INITIALIZATION:
        return {
          ...state,
          isLoading: true,
        }
      case GET_RECRUITMENT_JD_INVITATION.GET_RECRUITMENT_JD_INVITATION_SUCCESS:
        const jdInvitations: any = action.payload
        return {
          ...state,
          isLoading: false,
          jdInvitations,
        }
      case GET_RECRUITMENT_JD_INVITATION.GET_RECRUITMENT_JD_INVITATION_FAILED:
        return {
          ...state,
          isLoading: false,
        }

      case GET_SKILL_SET.GET_SKILL_SET_INITIALIZATION:
        return {
          ...state,
          isLoadingGetSkillSet: true,
        }
      case GET_SKILL_SET.GET_SKILL_SET_SUCCESS:
        const skillSetList: any = action.payload
        return {
          ...state,
          isLoadingGetSkillSet: false,
          skillSetList: skillSetList,
        }
      case GET_SKILL_SET.GET_SKILL_SET_ERROR:
        return {
          ...state,
          isLoadingGetSkillSet: false,
        }
      case GET_SKILL_SET.GET_SKILL_SET_RESET:
        return {
          ...state,
          skillSetList: [],
        }
      case GET_SKILL_SET_LIST.GET_SKILL_SET_LIST_INITIALIZATION:
        return {
          ...state,
          isLoadingSkillList: true,
        }
      case GET_SKILL_SET_LIST.GET_SKILL_SET_LIST_SUCCESS:
        const skillList: any = action.payload
        return {
          ...state,
          isLoadingSkillList: false,
          skillList: skillList,
        }
      case GET_SKILL_SET_LIST.GET_SKILL_SET_LIST_ERROR:
        return {
          ...state,
          isLoadingSkillList: false,
        }

      case SET_SKILL_SET.SET_SKILL_SET_INITIALIZATION:
        return {
          ...state,
          isLoadingSetSkillSet: true,
        }
      case SET_SKILL_SET.SET_SKILL_SET_SUCCESS:
        return {
          ...state,
          isLoadingSetSkillSet: false,
        }
      case SET_SKILL_SET.SET_SKILL_SET_ERROR:
        return {
          ...state,
          isLoadingSetSkillSet: false,
        }

      case PROCESS_JS_SKILL_SET.PROCESS_JS_SKILL_SET_INITIALIZATION:
        return {
          ...state,
          isLoadingProcessJDSkillSet: true,
        }
      case PROCESS_JS_SKILL_SET.PROCESS_JS_SKILL_SET_SUCCESS:
        return {
          ...state,
          isLoadingProcessJDSkillSet: false,
          ProcessJDSkillSet: action.payload,
        }
      case PROCESS_JS_SKILL_SET.PROCESS_JS_SKILL_SET_ERROR:
        return {
          ...state,
          isLoadingProcessJDSkillSet: false,
        }

      default:
        return state
    }
  }
)

export default reducer
